export { default } from './CardGeneric';
export * from './CardGeneric';
export * from './CardGeneric.Wide';
